import { Eye, Check, Trash2 } from "lucide-react";

export default function AdminComplaintRowActions({
  onView,
  onResolve,
  onDelete,
  isResolved,
  isSending,
}) {
  const buttonClass = `
  flex items-center justify-center gap-2
      lg:flex-row

  w-full lg:w-auto
  px-3 py-2
  lg:px-4 lg:px-5
  rounded-xl
  text-xs lg:text-sm
  font-medium
  text-white
  transition duration-200
  whitespace-nowrap
`;

  return (
    <div
      className="
        flex
        flex-col
        sm:flex-row
        gap-2 sm:gap-3
        w-full sm:w-auto
      "
    >
      <button
        onClick={onView}
        className={`${buttonClass} bg-blue-600 hover:bg-blue-500`}
      >
        <Eye size={16} />
        <span>View</span>
      </button>

      <button
        onClick={onResolve}
        disabled={isResolved || isSending}
        className={`${buttonClass} ${
          isResolved || isSending
            ? "bg-slate-600 cursor-not-allowed opacity-60"
            : "bg-green-600 hover:bg-green-500"
        }`}
      >
        <Check size={16} />
        <span>
          {isSending
            ? "Sending..."
            : isResolved
              ? "Resolved"
              : "Resolve & Send Email"}
        </span>
      </button>

      <button
        onClick={onDelete}
        className={`${buttonClass} bg-red-600 hover:bg-red-500`}
      >
        <Trash2 size={16} />
        <span>Delete</span>
      </button>
    </div>
  );
}
